
import React from 'react'
import * as R from 'ramda'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'
import IconButton from 'material-ui/IconButton'
import Divider from 'material-ui/Divider'
import DropDownMenu from 'material-ui/DropDownMenu'
import Toggle from 'material-ui/Toggle'
import DatePicker from 'material-ui/DatePicker'
import AutoComplete from 'material-ui/AutoComplete'
import { sort } from 'utils/stuff'
import Checkbox from 'material-ui/Checkbox'
import Colors from 'material-ui/styles/colors'


export default (o) => (
	<div
		style={{
			marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? '24px' : '10px'
		  , display: "block"
		  , paddingLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"8px":"auto"
		}}
	>
    <div style={{
			height: "60px"
		  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"0" : "-26px !important"
		  , verticalAlign: "middle"
		  , width: "30%"
		  , maxWidth: "100%"
		  , minWidth: "208px"
		  , paddingLeft: "8px"
		  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"0":"-8px !important"
		}}
		className="filters"
	>
      <AutoComplete
		fullWidth={true}
        hintText="Property alias"
		className="no-underline"
		inputStyle={{
			fontSize: "14px"
		  , height: "45px"
		  , lineHeight: "43px"
		  , paddingLeft:"10px"
		  , bottom: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "6px" : "16px"
		}}
		hintStyle={{
			fontSize: "14px"
		  , bottom: "30px"
		  , color: "#A0A0A0"
		  , paddingLeft:"10px"
		}}
		menuStyle={{
			maxHeight: "400px"
		  , overflowY: "auto"
		}}
        openOnFocus={true}
		filter={AutoComplete.caseInsensitiveFilter}
        dataSource={
			[...[{
				text: 'All'
				, value: (
                  <MenuItem
                    primaryText={"All"}
                    key={`Property-all-filters`}
                  />
                )
				, id: 'All'
			}],
			...((o.properties)?
            R.map((property) => ({
              text: property.alias,
              value: (
                <MenuItem
                  primaryText={property.alias}
                  key={`Property-${property._id}-filters`}
                />
              ),
              id: property._id
		  }),  sort(o.properties, "alias"))
          : [{text: '', value: ''}])
	  		]
        }
        onNewRequest={(obj)=> o.filtersUPD({property: obj.id})}
      />
    </div>
	<div
		className="include-yelp-filter"
		style={(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
			  {marginTop: "10px", marginLeft: "-12px"}
			  :{}
	}>
		<Checkbox
			label="Include Yelp Results"
			checked={o.yelpIsOn}
			onCheck={()=> {
				if(o.yelpIsOn){
					o.updCategoryYelp("")
				}else{
					o.updCategoryYelp("Real Estate Agents")
				}
				o.switchYelp()
			}}
			labelStyle={{
				color: "#9da8ad"
			  , textAlign: "left"
			}}
			iconStyle={{
				color: "#00d4b3"
			  , fill: "#00d4b3"
			}}
			style={{
				marginLeft: "60px"
	 		   , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"35px !important" : "auto"
			}}
		/>
	</div>
  </div>
)



// WEBPACK FOOTER //
// ./src/routes/manager/agents/AgentsFilters.js